<div class="post-bar">
    <a routerLink="/services" class="all-posts">
      <h5>View All Services</h5>
      <span></span>
    </a>
  </div>